import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";

export async function AddInvestorSessionID(user_name) {

    const Token = sessionStorage.getItem("Token");
    const accessToken = sessionStorage.getItem("access_token");
    
    const header = { Authorization: `Bearer ${Token}` };
    
    var raw = JSON.stringify({
        username: user_name,
        session_id: Token,
        access_token: accessToken || Token,
    });

    var requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: header,
    };
    console.log(requestOptions)
    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
                process.env.REACT_APP_ADD_INVESTOR_SESSIONID,
                requestOptions
            );
            if (!response.ok) {
                console.log("Could not generate user session");
                return false;
            } else {
                const message = await response.json();
                if (message["result"] !== "") {
                    return message["result"];
                } else {
                    console.log(message["error"]);
                    return false
                }
            }
        } catch (error) {
            if (error.name === "AbortError") {
                return 0
            }
            else {
                return 0
            }
        }
    }
    else{
        return 401
    }
}
